import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { IQuestion } from '@ebb-v2/ebb-integration';
import { cloneDeep } from '@apollo/client/utilities/common/cloneDeep';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  constructor(private _fb: FormBuilder) { }

  public questionSort(_questions: IQuestion[]): IQuestion[][] {
    const mappedQuestions: IQuestion[][] = [];
    let questionSetMax = 0;
    let questions =cloneDeep(_questions) ;
    questions.forEach(question => {
      if (question.questionSet > questionSetMax) {
        questionSetMax = question.questionSet;
      }
    });
    for (let i = 0; i < questionSetMax; i++) {
      const setArr = [];
      mappedQuestions.push(setArr);
    }
    questions.forEach(question => mappedQuestions[question.questionSet - 1].push(question));

    return mappedQuestions;
  }

  public buildSetFormGroup(questionSet: IQuestion[]): FormGroup {
    const group = {};

    questionSet.forEach(question => {
      const controlName: string = question.name.split(/[\s-]+/).map(el => el.toLowerCase()).join('-');
      group[controlName] = new FormControl(null, [
        Validators.required,
        ((control: AbstractControl) => {
          if (control.value !== question.qualification) {
            return { unqualified: true } 
          }
          return null;
        })
      ]);
    });

    return this._fb.group(group);
  }

  public buildQuestionnaireForm(...args: FormGroup[]): FormGroup {
    const formGroup = {};

    args.forEach((arg, index) => {
      const controlName = `set${index + 1}`;
      formGroup[controlName] = arg;
    });

    return this._fb.group(formGroup);
  }

  public buildFormConfig(questionData: IQuestion[][]): IQuestion[][] {
    questionData.forEach((questionSet: IQuestion[]) => {
      questionSet.forEach(question => question.controlName = question.name.split(/[\s-]+/).map(el => el.toLowerCase()).join('-'));
    });
    return questionData;
  }
}
